import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { ApplicationState, ThunkExtraArgument } from '../../types';

import { ErrorHandler } from './errorHandler';
import { Loader } from './loader';

interface ErrorComponentProps {
    retry(): void;
    dismiss?(): void;
}

const ErrorComponent = ({ retry, dismiss }: ErrorComponentProps) => (
    <ErrorHandler onTryAgain={retry} onDismiss={dismiss} />
);

interface Options {
    loadingStatusTextKey?: Mews.TextKey;
    dismissAction?(): AnyAction | ThunkAction<unknown, ApplicationState, ThunkExtraArgument, AnyAction>;
}

export const createViewLoadingError = ({ loadingStatusTextKey, dismissAction }: Options) => ({
    LoadingComponent: () => <Loader statusTextKey={loadingStatusTextKey} fill />,
    ErrorComponent: connect(undefined, { dismiss: dismissAction })(ErrorComponent),
});
